// extracted by mini-css-extract-plugin
export default {"logoSection":"NavbarLogo_logoSection__QXXL6","logoLink":"NavbarLogo_logoLink__NvJSz","logoImage":"NavbarLogo_logoImage__qytNK"};